// removed by extract-text-webpack-plugin
module.exports = {"container":"ScrollMessage-container","message":"ScrollMessage-message","loading":"ScrollMessage-loading","done":"ScrollMessage-done"};